export const registerModule = moduleName => ({
  type: "REGISTER_MODULE",
  name: moduleName
});

export const loadedModule = moduleName => ({
  type: "LOADED_MODULE",
  name: moduleName
});
